module.exports = __webpack_public_path__ + "static/media/4.3f730e7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/4.png
// module id = 1520
// module chunks = 0